jQuery(function ($) {

    var scorePercent = function (e, stars_holder) {
        var width = jQuery(stars_holder).width();
        var left = e.pageX - jQuery(stars_holder).offset().left;
        var offset = Math.min(Math.max(0, Page.isRTL() ? width - left : left), width);
        return Math.round((offset / width * 100 / 10) + 0.49) * 10;
    }

    var updateSelectedScore = function (score) {
        if (jQuery('#selected-rating span').length === 0) {
            return false;
        }

        var scoreClass = 'bad';

        if (score >= 4) {
            scoreClass = 'good';
        } else if (score >= 2.5) {
            scoreClass = 'neutral';
        }
        jQuery('#selected-rating span')
            .removeClass('bad')
            .removeClass('neutral')
            .removeClass('good')
            .addClass(scoreClass)
            .text(score.toFixed(1));
    }

    jQuery(document)
        .on('mousemove', '.editable-rating', function (e) {
            var percent = scorePercent(e, this);
            jQuery(this).find('.full-stars').width(percent + "%");

            var score = Math.round(percent * 10 / 100) / 10 * 5;

            updateSelectedScore(score);
        })

        .on('click', '.editable-rating', function (e) {
            e.stopPropagation();

            var isUserReviewForm = jQuery(this).closest('#write-review-form').length > 0;
            var $input = jQuery(this).find('input[type="hidden"]');

            var score = Math.round(scorePercent(e, this) * 10 / 100) / 10 * 5;

            if ($input.length > 0) {
                $input.val(score).change();
            }

            updateSelectedScore(score);
        })

        .on('mouseleave', '.editable-rating', function () {
            var $input = jQuery(this).find('input[type="hidden"]');
            var width = 0;

            if ($input.length > 0) {
                width = $input.val() * 20 + '%';
            }

            jQuery(this).find('.full-stars').width(width);

            updateSelectedScore(+$input.val());
        });
});

window.starRating = {
    init: function () {
        var starRatings = document.querySelectorAll('.stars-rating-not-rendered');

        //fallback
        if (!('IntersectionObserver' in window)) {
            Array.from(starRatings).forEach(function (rating) {
                starRating.render(rating);
            });
        } else {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.intersectionRatio > 0) {
                        observer.unobserve(entry.target);
                        starRating.render(entry.target);
                    }
                });
            }, {
                rootMargin: '50px 0px',
                threshold: 0.01
            });

            starRatings.forEach(function (rating) {
                observer.observe(rating);
            });
        }
    },
    render: function (rating) {
        var score = rating.dataset.rating;

        rating.innerHTML += '<div class="empty-stars stars-holder">' +
            '<i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>' +
            '</div>' +
            '<div class="full-stars" style="width: ' + (score * 10) + '%;">' +
            '<div class="stars-holder">' +
            '<i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>' +
            '</div>' +
            '</div>';

        setTimeout(function () {
            rating.classList.remove('stars-rating-not-rendered');
        }, 100);
    }
}

starRating.init();